
import { useMemo } from "react";
import type { ThemeCustomizations } from "../types";

export const useModernTemplateCustomizations = (
  meetingLink: any, 
  customizations: Record<string, any> = {}
) => {
  const themeCustomizations: ThemeCustomizations = useMemo(() => {
    const result = {
      backgroundColor: meetingLink?.background_color || customizations.backgroundColor,
      customFont: meetingLink?.custom_font || customizations.customFont,
      customLogoUrl: meetingLink?.custom_logo_url || customizations.customLogoUrl,
      backgroundImageUrl: meetingLink?.background_image_url || customizations.backgroundImageUrl,
      leftColumnBackgroundUrl: meetingLink?.left_column_background_url || customizations.leftColumnBackgroundUrl,
      // New logo properties
      logoBorderRadius: meetingLink?.logo_border_radius || customizations.logoBorderRadius || "none",
      logoSize: meetingLink?.logo_size || customizations.logoSize || "md",
      // Legacy support - convert old boolean to new format
      isLogoRounded: meetingLink?.is_logo_rounded || customizations.isLogoRounded || false,
      // Text color fields
      title_text_color: meetingLink?.title_text_color || customizations.title_text_color,
      description_text_color: meetingLink?.description_text_color || customizations.description_text_color,
      duration_text_color: meetingLink?.duration_text_color || customizations.duration_text_color,
      ...customizations
    };

    return result;
  }, [meetingLink, customizations]);

  const hasCustomBackground = useMemo(() => 
    !!(themeCustomizations.backgroundImageUrl || themeCustomizations.backgroundColor), 
    [themeCustomizations.backgroundImageUrl, themeCustomizations.backgroundColor]
  );

  return {
    themeCustomizations,
    hasCustomBackground
  };
};
